export default __webpack_public_path__ + "2d58fb667256de7fbab104b3a68699cf.png";